const map = {
	"./modal-image-bg-desktop.jpg": 77904,
	"./modal-image-cs-desktop.jpg": 84872,
	"./modal-image-de-AT-desktop.jpg": 92786,
	"./modal-image-hr-desktop.jpg": 3963,
	"./modal-image-hu-desktop.jpg": 74640,
	"./modal-image-ro-desktop.jpg": 68712,
	"./modal-image-sk-desktop.jpg": 3459
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45263;